import type { DefaultError } from '@tanstack/react-query'
import { ApiError } from '../api-client/api-error'
import { ZodParseError } from '../api-client/api-hooks'

export const getErrorMessage = (error: DefaultError) => {
  if (error instanceof ZodParseError) {
    return 'Something went wrong processing this request.'
  }

  if (error instanceof ApiError) {
    const { problemDetail: detail, problemTitle: title } = error
    if (detail) {
      return detail
    }

    if (title) {
      return title
    }
  }

  return 'An unexpected error occurred. Please try again.'
}

export const getErrorTitle = (error: DefaultError, prefix?: string) => {
  const errorTitle = error instanceof ApiError && error.problemTitle ? error.problemTitle : 'Unexpected issue'

  return prefix ? `${prefix}: ${errorTitle}` : errorTitle
}
